import React from 'react'
import { useTranslation } from 'react-i18next'

import { Text, Title } from '../../../components/presentation/Text'
import { useDynamicServiceOrder } from './_load/DynamicServiceOrderLoader'
import Icon from '../../../components/shapes/Icon'
import Separator from '../../../components/helpers/Separator'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Center from '../../../packages/kiti/components/helpers/Center'

const PageContent = () => {
  const { t } = useTranslation('listDynamicServiceOrders')
  const { configuration } = useDynamicServiceOrder()

  const titleMessage = configuration.titleMessage ? configuration.titleMessage : t('successTitle')
  const bodyMessage = configuration.bodyMessage ? configuration.bodyMessage : t('successBody')

  return (
    <Center height="100vh">
      <Panel paddingH="3rem" margin="1rem" open={true} noOverlay>
        <Separator weight={4} />
        <Center>
          <Icon name="BsTrophy" size="2rem" />
        </Center>
        <Separator weight={4} />
        <Title size="h4" align="center">
          {titleMessage}
        </Title>
        <Text align="center">{bodyMessage} </Text>
        <Separator weight={4} />
      </Panel>
    </Center>
  )
}

export default PageContent
